var InlineSVGConfig = (function () {
    function InlineSVGConfig() {
    }
    return InlineSVGConfig;
}());
export { InlineSVGConfig };
